import { Nullable } from "common/types";
import { Record } from "immutable";

export const calculatedFinancingFromJSON = (json: Partial<ICalculatedFinancingData>): CalculatedFinancingRecord => {
  const recordData: ICalculatedFinancingRecord = { ...(json as any) };

  return new CalculatedFinancingRecord(recordData);
};

export interface ICalculatedFinancingData {
  error?: Nullable<string>;
  estimate_id?: Nullable<number>;
  finance_option_id?: Nullable<number>;
  financed_amount?: number;
  loading?: boolean;
  monthly_payment?: number;
  promo_payment?: number;
}

export interface ICalculatedFinancingRecord {
  error: Nullable<string>;
  estimate_id: Nullable<number>;
  finance_option_id: Nullable<number>;
  financed_amount: number;
  loading: boolean;
  monthly_payment: number;
  promo_payment: number;
}

export const defaultCalculatedFinancingProps: ICalculatedFinancingRecord = {
  error: null,
  estimate_id: null,
  finance_option_id: null,
  financed_amount: 0,
  loading: false,
  monthly_payment: 0,
  promo_payment: 0,
};

export class CalculatedFinancingRecord
  extends Record(defaultCalculatedFinancingProps)
  implements ICalculatedFinancingRecord {}
